import { api } from 'redux/api/index.api';
import { setBusinessOrganizationInStorage } from 'utils/organisation-utils';

export const businessOrganizationsApi = api.injectEndpoints({
  endpoints: builder => ({
    fetchOrganization: builder.query({
      query: ({ organizationId }) => ({
        url: `organizations/${organizationId}`,
        method: 'GET',
      }),
      async onQueryStarted(_args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          setBusinessOrganizationInStorage(data);
        } catch (err) {
          console.error('Error fetching organization:', err);
        }
      },
    }),
    fetchUserAccessInfo: builder.query({
      query: () => ({
        url: 'user',
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: 'throw',
});

export const {
  useFetchOrganizationQuery,
  useLazyFetchOrganizationQuery,
  useFetchUserAccessInfoQuery,
} = businessOrganizationsApi;
